import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

/** Shared control look: 48px (md) or 36px (compact/admin), surface fill, hairline border. */
export const controlClass =
	'w-full rounded border border-line bg-surface text-[15px] text-ink transition-[border-color,box-shadow] placeholder:text-[#A39B8D] hover:border-[#C9BFAB] focus:border-ink focus:shadow-[0_0_0_3px_rgba(27,25,21,.06)] focus:outline-none disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-bad'

export interface InputProps
	extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
	/** md = 48px (site/forms), compact = 36px (admin) */
	uiSize?: 'md' | 'compact'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, uiSize = 'md', ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					controlClass,
					uiSize === 'compact' ? 'h-9 px-3 text-ui' : 'h-12 px-4',
					'file:border-0 file:bg-transparent file:text-sm file:font-medium',
					className,
				)}
				ref={ref}
				{...props}
			/>
		)
	},
)
Input.displayName = 'Input'

export { Input }
